<template>
  <div class="map-pedido" @click="selecionar()">
    <div class="map-pedido__header d-flex align-items-center">
      <b class="map-pedido__numero mr-2">#{{p.id_contador}}</b>
      <div class="map-pedido__origem">
        <span class="badge border border-dark" title="Pedido realizado no App ou Site" v-if="p.origin === '1'">App/Site</span>
        <span class="badge border border-dark" title="Pedido realizado via Pedido Manual" v-else-if="p.origin === '3'">Manual</span>
        <span class="badge border border-dark" title="Pedido realizado via Qr Code no local" v-else-if="p.origin === '4'">Qr Code</span>
        <span class="badge badge-success" title="Pedido realizado via Bot WhatsApp" v-else-if="p.origin === '5'">LeBot</span>
        <span class="badge badge-danger" v-else-if="p.origin === '6'">iFood</span>
        <span class="badge text-white" style="background-color: #FB3B01" v-else-if="p.origin === '7'">UaiRango</span>
        <span v-else-if="p.origin === '11'" class="badge badge-warning">99Food</span>
      </div>
      <button v-if="routeControl" class="btn btn-sm text-success ml-auto" title="Vincular à rota" @click.stop="$emit('vincularRota', $event)">
        <i class="fa fa-route"></i> <i class="fa fa-plus"></i>
      </button>
      <div v-if="controls" class="map-pedido__controls d-flex ml-auto">
        <button class="btn btn-sm map-pedido__action map-pedido__action--remove" title="Remover pedido da rota"
                @click.stop="$emit('selecionar')">
          <i class="fa fa-trash-alt"></i>
        </button>
        <button class="btn btn-sm map-pedido__action map-pedido__action--drag drag ml-1" title="Arrastar para alterar a ordem"
                @click.stop>
          <i class="fa fa-bars"></i>
        </button>
      </div>
    </div>

    <div class="map-pedido__details small">
      <div class="map-pedido__info">
        <i class="fa fa-map-marker-alt map-pedido__info-icon"></i>
        <span>{{p.logradouro}}, {{p.numero}}, <span class="text-nowrap">{{p.bairro}}</span></span>
      </div>
      <div v-if="p.complemento" class="map-pedido__complemento">{{p.complemento}}</div>
      <div class="map-pedido__info">
        <i class="fa fa-user map-pedido__info-icon"></i>
        <span><span class="text-muted">Cliente:</span> <b>{{p.nome_cliente || 'Não informado'}}</b></span>
      </div>
      <div v-if="!p.coordinates"><span class="badge badge-warning">Sem Localização</span></div>
      <div v-else-if="p.localizacao_aproximada"><span class="badge badge-info">Localização aproximada</span></div>
    </div>

    <div class="map-pedido__footer small d-flex align-items-center justify-content-center mt-1 pt-1">
      <div :class="{'text-warning': p.data_agendamento}" class="map-pedido__metric d-flex align-items-center">
        <i class="fa fa-clock mr-1"></i>
        <span v-if="p.data_agendamento"><b>Agendado:</b> {{ formatarPrevisao(p.data_agendamento) }}</span>
        <span v-else><b>Previsão:</b> {{ formatarPrevisao(p.data_previsao) }}</span>
      </div>
      <div v-if="p.distance > 1" class="map-pedido__metric map-pedido__distance d-flex align-items-center ml-3 pl-3">
        <i class="fa fa-map-marked-alt mr-1"></i>
        <span><b>Distância:</b> {{ p.distance | kilometer }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MapPedido",
  props: ['p', 'controls', 'routeControl', 'selected'],
  methods: {
    formatarPrevisao(data) {
      const previsao = this.$dayjs(data);
      return previsao.isValid() ? previsao.format('HH:mm') : '-';
    },

    selecionar() {
      if (!this.controls) {
        this.$emit('selecionar');
      }
    }
  },

  filters: {
    max(text) {
      return text && text.length > 12 ? text.slice(0 , 12) + '...' : text;
    },

    entrega(status) {
      return status === '1' ? 'Aguardando coleta' : (status === '2' ? 'Em Rota' : 'Pedido entregue')
    }
  }
}
</script>

<style scoped>
.map-pedido__numero {
  font-size: 1rem;
}

.map-pedido__details {
  margin-top: .3rem;
  line-height: 1.35;
}

.map-pedido__info {
  display: flex;
  align-items: baseline;
  min-width: 0;
}

.map-pedido__info-icon {
  flex: 0 0 18px;
  width: 18px;
  text-align: center;
  margin-right: .35rem;
}

.map-pedido__complemento {
  padding-left: 24px;
  color: #6c757d;
}

.map-pedido__action {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: 1px solid transparent;
}

.map-pedido__action--remove {
  color: #dc3545;
  background: #fff1f3;
  border-color: #fbd5da;
}

.map-pedido__action--drag {
  color: #5a5c69;
  background: #f1f3f5;
  border-color: #e2e6ea;
  cursor: grab;
}

.map-pedido__action--drag:active {
  cursor: grabbing;
}

.map-pedido__metric {
  white-space: nowrap;
}

.map-pedido__distance {
  border-left: 1px solid #e3e6f0;
}

@media (max-width: 420px) {
  .map-pedido__footer {
    align-items: center !important;
    flex-direction: column;
  }

  .map-pedido__distance {
    margin-top: .35rem;
    margin-left: 0 !important;
    padding-left: 0 !important;
    border-left: 0;
  }
}

</style>
